import { InterfaceIcon, getSvgIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from './AccountDropdown.styles';
const AccountDropdown = (props) => {
    const [open, setOpen] = React.useState(false);
    const containerRef = useOutsideClick(() => setOpen(false));
    const buttonRef = React.useRef(null);
    const itemsRef = React.useRef([]);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: containerRef },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Button, { ref: buttonRef, "aria-haspopup": "menu", "aria-expanded": open, "aria-controls": `account-options`, "aria-label": props.label, onClick: () => {
                    setOpen(!open);
                    props.onClick?.();
                }, onKeyDown: (event) => {
                    switch (event.key) {
                        case 'ArrowDown':
                            if (!open) {
                                setOpen(true);
                            }
                            itemsRef.current[0]?.focus();
                            break;
                        case 'Escape':
                            setOpen(false);
                            break;
                    }
                } },
                React.createElement("span", null, props.label),
                " ",
                getSvgIcon(InterfaceIcon.User),
                ' ',
                getSvgIcon(InterfaceIcon.Chevron),
                React.createElement(S.ActiveIndicator, null, getSvgIcon(InterfaceIcon.Tick)))),
        React.createElement(S.Links, { id: `account-options`, role: "menu" }, props.items.map((item, i) => (React.createElement("li", { key: `account-options-${i}`, role: "none" },
            React.createElement(S.Link, { ref: (el) => (itemsRef.current[i] = el), tabIndex: open ? undefined : -1, href: item.url, role: "menuitem", onKeyDown: (event) => {
                    const nextIndex = i === props.items.length - 1 ? 0 : clamp(i + 1, props.items.length - 1);
                    const prevIndex = i === 0 ? props.items.length - 1 : clamp(i - 1, props.items.length - 1);
                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault();
                            event.stopPropagation();
                            itemsRef.current[nextIndex]?.focus();
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            event.stopPropagation();
                            itemsRef.current[prevIndex]?.focus();
                            break;
                        case 'Escape':
                            setOpen(false);
                            buttonRef.current?.focus();
                            break;
                        default:
                            break;
                    }
                } },
                getSvgIcon(item.icon),
                React.createElement("span", null, item.text))))))));
};
export default AccountDropdown;
